type RefrigerantGasIconProps = {
  color?: string;
  size?: string | number;
};

export const RefrigerantGasIcon = ({ size = '20', color = 'currentColor' }: RefrigerantGasIconProps): JSX.Element => (
  <svg width={size} height={size} viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.22016 4.44443L7.72809 4.04761L5.84317 1.66666H3.95825L6.22016 4.44443Z" fill={color} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.66455 17.6339V18.3333H9.61285H13.5611V17.6339V16.9345H9.61285H5.66455V17.6339Z"
      fill={color}
    />
    <path d="M13.0687 4.44443L11.498 4.04761L13.3829 1.66666H15.2678L13.0687 4.44443Z" fill={color} />
    <path d="M8.48218 2.4603H10.7441V4.0476H8.48218V2.4603Z" fill={color} />
    <path
      d="M3.95825 6.94613C3.95825 5.3453 5.19109 4.04758 6.71187 4.04758H12.5142C14.0349 4.04758 15.2678 5.3453 15.2678 6.94613V13.4506C15.2678 15.0514 14.0349 16.3492 12.5142 16.3492H6.71188C5.19109 16.3492 3.95825 15.0514 3.95825 13.4506V6.94613Z"
      fill={color}
    />
    <path d="M3.95825 8.01575H15.2678V12.7777H3.95825V8.01575Z" fill={color} />
  </svg>
);
